import {getServerTexts as getTexts, initTexts, texts} from '../../Localization/texts';

const entity = 'UI_FEATURES';

const en = {
    firstMessageTitle: 'Verify your email address with',
    firstMessageDescP1: 'Make sure this is your company email address.',
    firstMessageDescP2:
        'After you click Verify, you will receive an email to complete the process.',
    preInputText: 'My company email address',
    secondMessageTitle: 'Check Your Inbox',
    expirationText: 'The email is valid for one hour only.',
    secondMessageDescP1: 'Confirm the email we sent you to complete the process.',
    secondMessageDescP2: "Didn't receive an email from us? Check your",
    userEmail: 'email address.',
    confirmBtn: 'OK',
    emailPlaceholder: 'email@mail.com',
    cancelBtn: 'Cancel',
    verifyBtn: 'Verify',
    messageTitle: 'Email Address Changed',
    confirmEmailChange:
        "You changed your email address, so it doesn't match the one defined for your user. It will be updated in the Personnel File form."
};

const he = {
    firstMessageTitle: 'אימות האימייל שלכם ב-',
    firstMessageDescP1: 'וודאו שזו כתובת האימייל הארגונית שלכם.',
    firstMessageDescP2: 'לאחר שתלחצו על אישור תקבלו אימייל לכתובת הזו כדי לסיים את התהליך.',
    preInputText: 'כתובת האימייל הארגונית שלי',
    secondMessageTitle: 'שלחנו אימייל',
    expirationText: 'האימייל תקף לשעה אחת בלבד.',
    secondMessageDescP1: 'אשרו את האימייל שנשלח לכתובת שציינתם כדי להשלים את תהליך האימות.',
    secondMessageDescP2: 'לא קיבלתם אימייל? בדקו את',
    userEmail: 'כתובת האימייל שלכם.',
    confirmBtn: 'אישור',
    emailPlaceholder: 'email@mail.com',
    cancelBtn: 'ביטול',
    verifyBtn: 'אישור',
    messageTitle: 'כתובת אימייל עודכנה',
    confirmEmailChange:
        'שינית את כתובת האימייל והיא כבר לא תואמת לכתובת המוגדרת למשתמש שלך. לכן, הכתובת החדשה תתעדכן במסך כרטיס עובד.'
};

const fallbacks = {
    en,
    he
};

export const mapping = {
    26: 'firstMessageTitle',
    28: 'firstMessageDescP1',
    36: 'firstMessageDescP2',
    29: 'secondMessageTitle',
    30: 'secondMessageDescP2',
    31: 'expirationText',
    32: 'secondMessageDescP1',
    33: 'userEmail',
    34: 'confirmBtn',
    35: 'emailPlaceholder',
    37: 'verifyBtn',
    38: 'preInputText'
};

export function getServerTexts() {
    return getTexts(entity, mapping);
}

// init texts fallbacks accoring to the user's locale
initTexts(entity, fallbacks);

// export entity texts
// usage: import texts from './texts'
export default texts[entity];
